import { render, staticRenderFns } from "./CustomMarkingDetails.vue?vue&type=template&id=77210c2b&scoped=true"
import script from "./CustomMarkingDetails.vue?vue&type=script&lang=js"
export * from "./CustomMarkingDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomMarkingDetails.vue?vue&type=style&index=0&id=77210c2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77210c2b",
  null
  
)

export default component.exports